import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=An%20artistic%20abstract%20background%20with%20flowing%20gradients%20of%20warm%20coral%20peach%20and%20cream%20tones%20in%20a%20soft%20watercolor%20style%2C%20ethereal%20atmosphere%20with%20subtle%20brush%20textures%2C%20elegant%20fluid%20shapes%2C%20no%20recognizable%20objects%2C%20pure%20abstract%20art%20suitable%20for%20website%20hero%20background&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-3xl">
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: 'var(--font-heading)' }}>
            无删减韩国漫画 <span className="text-accent-400">下拉式</span>阅读
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
            爱漫画汇聚海量无删减韩国漫画，提供流畅下拉式在线阅读体验。每日更新热门韩漫，满足您对韩漫的多样需求。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category"
              className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-base font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
            >
              <i className="ri-book-open-line mr-2"></i>开始阅读
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-full text-base font-medium hover:bg-white/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-information-line mr-2"></i>了解更多
            </Link>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 -translate-x-1/2">
          <div className="flex items-center gap-1 text-white/50 text-sm">
            <span>向下滚动</span>
            <i className="ri-arrow-down-s-line animate-bounce"></i>
          </div>
        </div>
      </div>
    </section>
  );
}